<template>
  <div class="report-viewer__container">
    <loading
      :can-cancel="false" 
      :is-full-page="false"
      :active.sync="isLoading" 
      class="loader">
  
    </loading>
    <iframe
      :src="reportSource"
      class="report-viewer"
      frameborder="0"
      v-if="reportSource"
    ></iframe>
    <NoPreview v-else/>
  </div>
</template>

<script>
import NoPreview from '../components/NoPreview'
export default {
  props: {
    reportType: {
      type: String,
      default: 'iframe'
    },
    reportSource: {
      type: String,
      default: ''
    },
    isLoading:{
      type: Boolean,
      default: false,
    }
  },
  components: {
    NoPreview
  },
  created() {

  }
}
</script>

<style lang="scss" scoped>
  .report-viewer__container {
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .report-viewer {
    width: 100%;
    height: 100%;
  }

</style>